export default __webpack_public_path__ + "static/media/money-logo.0aafc537.svg";